export enum FilterType {
  ProgrammeCareerStagesExperienceEE = "Programme Career Stages Experience (EE)",
  ProgrammeCareerStagesTopic = "Programme Career Stages Topic",
  ProgrammeCareerStagesFormat = "Programme Career Stages Format",
}
